import { useMemo } from 'react';
import { useReadContract } from 'wagmi';
import { getRoundDataFromBlockchainResponse } from '../../utils/blockchain-helpers.ts';
import { ENV_CONSTS } from '../../utils/env-consts.ts';
import { abi } from '../../ABIs/abi.ts';
import { useIsBlockchainVersion } from '../../hooks/useIsBlockchainVersion.ts';

export const useGameRoundDataBlockchainQuery = (
  round: Maybe<bigint>,
  queryConfig?: QueryConfig
) => {
  const blockchainVersion = useIsBlockchainVersion();
  const enabled = !!round && queryConfig?.enabled !== false && blockchainVersion;

  const { data: blockchainData, ...rest } = useReadContract({
    address: ENV_CONSTS.BLOCKCHAIN_CONTRACT_ADDRESS,
    abi,
    functionName: 'getRoundData',
    args: [round!],
    query: {
      ...queryConfig,
      enabled,
    },
  });

  const data = useMemo(() => {
    if (!blockchainData) return undefined;
    return getRoundDataFromBlockchainResponse(blockchainData);
  }, [blockchainData]);

  return useMemo(
    () => ({
      ...rest,
      data,
    }),
    [data, rest]
  );
};

type QueryConfig = {
  enabled?: boolean;
};
